import { setBufferImageIds, setImageSrc, setImageHref, setBarcode, setBlank } from './actions'
import { decodeBarcodeQueue, isBlankImageQueue } from './taskQueue'
import { getImageURL } from '../buffer'
import type { BufferChangeInfo, ImageID } from '../types'

const imageUrlParse = async (imageId: ImageID) => {
    const { imageUrl } = await getImageURL(imageId)

    await setImageSrc({ imageId, imageSrc: imageUrl }, `handleBufferAdd ${imageUrl} src`)
    await setImageHref({ imageId, imageHref: imageUrl }, `handleBufferAdd ${imageUrl} href`)

    console.debug(`handleBufferAdd url set`, { imageId, imageUrl })
}

const blankParse = async (imageId: ImageID) => {
    const isBlank = await isBlankImageQueue(imageId)
    console.debug(`handleBufferAdd blank`, { imageId, isBlank })
    if (isBlank) {
        await setBlank({ imageId, isBlank }, `handleBufferAdd ${imageId} blank`)
        console.debug(`handleBufferAdd blank set`, { imageId, isBlank })
    }
}

const barcodeParse = async (imageId: ImageID) => {
    const barcode = await decodeBarcodeQueue(imageId)
    console.debug(`handleBufferAdd bc`, { imageId, barcode })
    await setBarcode({ imageId, barcode }, `handleBufferAdd ${imageId} bc`)
    console.debug(`handleBufferAdd bc set`, { imageId, barcode })
}

export const handleBufferAdd = async (info: BufferChangeInfo): Promise<void> => {
    try {
        console.debug('handleBufferAdd', info)
        await imageUrlParse(info.currentId)
        await blankParse(info.currentId)
        await barcodeParse(info.currentId)
    } catch (e) {
        console.debug('handleBufferAdd error', info)
        console.error(e)
    }
}

export const handleBufferRemove = async (info: BufferChangeInfo): Promise<void> => {
    await Promise.resolve()
    console.debug('handleBufferRemove', info)
}

export const handleBufferChange = async (info: BufferChangeInfo): Promise<void> => {
    console.debug('handleBufferChange', info)
    const ids = await setBufferImageIds(info.imageIds, 'handleBufferChange')
    console.debug('handleBufferChange ids set', ids)

    if (info.action === 'add') {
        await handleBufferAdd(info)
        return
    }

    if (info.action === 'remove') {
        await handleBufferRemove(info)
        return
    }

    if (info.action === 'shift') {
        return
    }

    throw new Error(`Why? ${info.action}`)
}

export default { handleBufferAdd, handleBufferRemove, handleBufferChange }
